var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.504883 6.41309H4.40305V19.9987H0.504883V6.41309Z",
    fill: "#9EA4A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.35419 4.71379H2.32596C0.914864 4.71379 0 3.67525 0 2.3601C0 1.01806 0.94191 0 2.38123 0C3.81938 0 4.70367 1.01549 4.73189 2.35626C4.73189 3.6714 3.81938 4.71379 2.35419 4.71379Z",
    fill: "#9EA4A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0005 19.9997H15.5802V12.9681C15.5802 11.1279 14.8888 9.87296 13.3683 9.87296C12.2054 9.87296 11.5586 10.7194 11.2576 11.5377C11.1447 11.8297 11.1623 12.2382 11.1623 12.648V19.9997H6.7832C6.7832 19.9997 6.83965 7.54487 6.7832 6.41285H11.1623V8.545C11.421 7.61274 12.8204 6.28223 15.0534 6.28223C17.8239 6.28223 20.0005 8.23766 20.0005 12.4443V19.9997Z",
    fill: "#9EA4A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b328a8ae11f0263367a400f9f58d2431.svg";
export { ForwardRef as ReactComponent };